import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H2, H4 } from "../../AbstractElements";
import { formatMontant, truncateText, URL_API } from "../../utils/helper/helpers";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

import { formatDate, formatPrice, itemHasPermission } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import useInfosEts from "../InfosEts/InfoApi";
import { Link } from "react-router-dom";
import { deleteRecu, useRecuListe } from "./apiFacture";

type Facture = { [key: string]: any }

const GestRecu = () => {
    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [filteredItems, setFilteredItems] = useState<Facture[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const recus = useRecuListe(refresh) || [];
    const etablissement = useInfosEts(refresh) || [];

    const [data, setData] = useState({
        num: '',
        client: '',
        motif: '',
        montant: '',
        etsInfos: 0,
        date_recu: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        num: '',
        client: '',
        motif: '',
        etsInfos: '',
        montant: '',
        date_recu: '',
        id: null
    });

    const [filter, setFilter] = useState({
        month: '',
        date_debut: '',
        date_fin: '',
        status: ''
    });

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formattedValue = name == 'montant' ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const clearDataForm = () => {
        setData({
            num: '',
            client: '',
            motif: '',
            montant: '',
            etsInfos: 0,
            date_recu: '',
            id: null
        });
        setErreur({
            num: '',
            client: '',
            motif: '',
            montant: '',
            etsInfos: '',
            date_recu: '',
            id: null
        });
    }

    const editerData = ({ id }: { id: number }) => {
        const data = filteredItems.find((item) => item.id === id);
        if (data) {
            setData({
                num: data.num,
                client: data.client,
                motif: data.motif,
                montant: data.montant,
                etsInfos: data.ets_id,
                date_recu: data.date_recu,
                id: data.id
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        console.log(data)
        const url = data.id !== null ? `${URL_API}/recu/update/${data.id}` : `${URL_API}/recu/store`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "Reçu modifié avec succès !!" : "Reçu ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }


        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.status == 422) {
                setErreur(error.response.data.message);
            }
            console.log(error)
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }
    const handleSubmit = () => {
        const month = selectedMonth ? selectedMonth : new Date().getMonth() + 1
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: `De Vouloir Payer les bons du ${month} eme mois ??`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Payer !'
        }).then((result) => {
            if (result.isConfirmed) {
                // monthPayed({ value: month }, () => setRefresh(!refresh))
            }
        });

    };

    // Fonction pour gérer le changement de filtre
    const changeFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter((prev) => ({ ...prev, [name]: value }));
    };

    const Confirmation = ({ id }: { id: number}) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir Supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('id',id)
                deleteRecu({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // Mois actuel (1-12)
        let filtered = recus;
        filtered = recus.filter((item) => {
            const itemMonth = new Date(item.date_recu).getMonth() + 1;
            const matchesMonth = selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = item.num && item.num.toLowerCase().includes(filterText.toLowerCase()) ||
                item.ets_nom && item.ets_nom.toLowerCase().includes(filterText.toLowerCase()) ||
                item.client && item.client.toLowerCase().includes(filterText.toLowerCase()) ||
                item.date_recu && item.date_recu.toLowerCase().includes(filterText.toLowerCase());
            return matchesMonth && matchesSearch;
        });

        // Filtrer par statut
        if (filter.status) {
            filtered = filtered.filter((item) => item.status === filter.status);
        }

        etablissement.map((item, index) => {
            if (item.status == 'actif' && item.is_default == 1) {
                setData((prevState) => ({
                    ...prevState,
                    etsInfos: item.id ?? 0
                }));
            }
        })

        setFilteredItems(filtered);
        setTimeout(() => {
            if (filteredItems.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false)
              }
          }, 2000);
    }, [recus, filterText, filter, selectedMonth, etablissement, refresh]);

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    return (
        <div className='page-body'>
            {isLoading && filteredItems.length > 0 ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Container fluid>
                        <Row>
                            <Col lg="8">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col sm="6">
                                                <Label className="me-2">Rechercher:</Label>
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    value={filterText}
                                                />
                                            </Col>
                                            <Col sm="6">
                                                <Label className="me-2">Filtrer par mois:</Label>
                                                <Input name="type" value={selectedMonth || ''} onChange={handleMonthChange} type="select">
                                                    <option value="">Mois actuel</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </Input>
                                            </Col>

                                        </Row>

                                    </CardBody>
                                </Card>
                                <Table responsive id="all-invoice" striped={true}>
                                    <thead className="bg-info">
                                        <tr>
                                            <th className="text-white">Id</th>
                                            <th className="text-white ps-4">No Reçu</th>
                                            <th className="text-white ">Clients</th>
                                            <th className="text-white ">Montants</th>
                                            <th className="text-white ">Motifs</th>
                                            <th className="text-white ">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItems.map((item, index) => (
                                            <tr key={item.id}>
                                                <th scope='row'>
                                                    <span className="fw-bold">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.num}
                                                    </span> <br></br>
                                                    <span>
                                                        {formatDate(item.date_recu)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.client}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {formatPrice(item.montant)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {truncateText(item.motif, 20)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link className='btn bg-dark btn-xs mx-1 my-1' to={`/factures/recus/show/${item.id}`}>
                                                        <i className='fa fa-eye'></i>
                                                    </Link>
                                                    {
                                                        (itemHasPermission('super admin') || itemHasPermission('gest. factures ecriture')) && (

                                                            item.status === 'payed' ? (
                                                                null
                                                            ) : (
                                                                <>
                                                                    <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerData({ id: item.id })}>
                                                                        <i className='fa fa-pencil'></i>
                                                                    </Btn>
                                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id})}>
                                                                        <i className='fa fa-trash'></i>
                                                                    </Btn>
                                                                </>
                                                            )

                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col lg="4">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitData}>
                                            <H4 className="mb-4 text-capitalize">
                                                {data.id == null ? ("Faire un reçu") : (`Modifier le reçu ${data.num}`)}
                                            </H4>
                                            <div className="product-info">
                                                <div className="product-group">
                                                    <Row>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Etablissement</Label>
                                                                <Input
                                                                    placeholder="Entrer le type"
                                                                    name="etsInfos"
                                                                    value={data.etsInfos}
                                                                    onChange={changeHandler}
                                                                    type="select"
                                                                    className="form-control" disabled
                                                                >
                                                                    <option value=''>Selectionner...</option>
                                                                    {
                                                                        etablissement.map((item, index) => {
                                                                            if (item.status == 'actif' && item.is_default == 1) {
                                                                                return <option key={index} value={item.id} selected={true}>{item.nom}</option>
                                                                            } return null;
                                                                        })
                                                                    }
                                                                </Input>
                                                                {erreur.etsInfos && (
                                                                    <span className="text-danger">{erreur.etsInfos}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>No Reçu</Label>
                                                                <Input
                                                                    placeholder="Entrer l'numéro de reçu"
                                                                    name="num"
                                                                    value={data.num}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.num && (
                                                                    <span className="text-danger">{erreur.num}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Nom client</Label>
                                                                <Input
                                                                    placeholder="Entrer la nom complet du client"
                                                                    name="client"
                                                                    value={data.client}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.client && (
                                                                    <span className="text-danger">{erreur.client}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Montant</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="montant"
                                                                    value={data.montant}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.montant && (
                                                                    <span className="text-danger">{erreur.montant}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Date</Label>
                                                                <Input
                                                                    placeholder="date"
                                                                    name="date_recu"
                                                                    value={data.date_recu}
                                                                    onChange={changeHandler}
                                                                    type="date"
                                                                />
                                                                {erreur.date_recu && (
                                                                    <span className="text-danger">{erreur.date_recu}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Motif</Label>
                                                                <Input
                                                                    placeholder="Entrer le Motif"
                                                                    name="motif"
                                                                    value={data.motif}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.motif && (
                                                                    <span className="text-danger">{erreur.motif}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. factures ecriture')) && (
                                                    <div className="text-end">
                                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                                            {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                                        </Btn>
                                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                            Annuler
                                                        </Btn>
                                                    </div>
                                                )}

                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                 </>
            )}
        </div>
    );
};

export default GestRecu